<div class="container-fluid page">
    <div class="d-flex page__box p-3 mt-2"><img (click)="dataPage()" src="./assets/arrow_logo.png" class="arrow"
         >&nbsp;&nbsp;Conduct a New Survey</div>
    <div class="example-header">
        <mat-card class="matCardForm">
            <mat-card-content class="pa-1">
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="fulllwidth">

                        <mat-form-field>
                            <input type="text" formControlName="name" required matInput placeholder="Name">
                            <!-- <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
                              </mat-error> -->
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" formControlName="surveyLink" id="surveyLink" required matInput
                                placeholder="Survey Link">
                        </mat-form-field>

                        <mat-form-field>
                            <input type="text" formControlName="resultLink" id="resultLink" required matInput
                                placeholder="Result Link">
                        </mat-form-field>

                        
                        <div>
                            <span>
                                <mat-form-field style="width: 48%;">
                                    <mat-label>Roles</mat-label>
                                    <mat-select  formControlName="roles" multiple >
                                        <mat-option *ngFor="let food of rolebased" [value]="food.role">
                                            {{food.role}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>&nbsp;
                            </span> &nbsp;&nbsp;
                            <span>
                                <mat-form-field  style="width: 48%;">
                                    <mat-label>Target States</mat-label>
                                    <mat-select formControlName="targetstate" multiple >
                                        <mat-option *ngFor="let states of targetstateList" [value]="states">
                                            {{states}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </span>
                        </div>
                       

                        <mat-form-field>
                            <input type="text" maxlength="100" rows="2" formControlName="remark" matInput placeholder="Remark">
                            <!-- <mat-error *ngIf="form.get('SchemtTitle').hasError('required')">
                              </mat-error> -->
                        </mat-form-field>

                        <div class="row">
                            <div class="col-md-8">
                            </div>
                            <div class="col-md-4">
                                <button mat-button type="submit" [disable]="disable"
                                    class="submitBtn pull-right">Send</button>
                            </div>
                        </div>

                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>